import React from 'react';
import { Award, Leaf, Wallet, Clock, ShieldCheck, Heart } from 'lucide-react';

const FEATURES = [
  { Icon: Award, title: 'Experienced Professionals', desc: 'Certified technicians with 15+ years of expertise.' },
  { Icon: Leaf, title: 'Safe & Eco-Friendly', desc: 'Government-approved chemicals safe for kids and pets.' },
  { Icon: Wallet, title: 'Affordable Pricing', desc: 'Transparent pricing with no hidden charges.' },
  { Icon: Clock, title: 'Quick Response Time', desc: 'Same-day appointment for emergency requests.' },
  { Icon: ShieldCheck, title: 'Guaranteed Results', desc: 'Free re-treatment if pests return within warranty.' },
  { Icon: Heart, title: 'Customer Satisfaction', desc: '10,000+ happy homes across Uttarakhand.' },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why-choose"
      data-testid="why-choose-section"
      className="py-16 sm:py-20 lg:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-14">
          <span className="inline-block text-xs sm:text-sm font-semibold uppercase tracking-wider text-brand-green">Why Choose Us</span>
          <h2
            className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-blue"
            style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
            data-testid="why-choose-title"
          >
            The EntoRid Difference
          </h2>
          <p className="mt-3 text-base text-gray-600">Six reasons families across India trust us.</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {FEATURES.map(({ Icon, title, desc }) => (
            <div
              key={title}
              data-testid={`why-feature-${title.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`}
              className="rounded-2xl p-5 sm:p-6 bg-slate-50/60 ring-1 ring-gray-100 hover:ring-brand-green/40 hover:bg-white transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-green/10 text-brand-green flex items-center justify-center mb-4">
                <Icon size={22} strokeWidth={2} />
              </div>
              <h3 className="text-base sm:text-lg font-semibold text-brand-blue mb-1">{title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
